<template>
<!--  <h1>Login</h1>-->
<!--  <div class="wrap">-->
<!--    <div class="form">-->
<!--      <div class="input-wrapper">-->
<!--        <p>Login</p>-->
<!--        <input type="text">-->
<!--      </div>-->
<!--      <div class="input-wrapper">-->
<!--        <p>Password</p>-->
<!--        <input type="password">-->
<!--      </div>-->
<!--      <div>-->
<!--        <button class="btn primary">Login</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="login-form">
    <h2>Авторизация</h2>
    <div v-if="error" class="error">
      {{ error }}
    </div>

    <form class="form" @submit.prevent="login">
      <div class="input-wrapper">
        <label for="username">Имя пользователя:</label>
        <input type="text" id="username" v-model="username" required />
      </div>
      <div class="input-wrapper">
        <label for="password">Пароль:</label>
        <input type="password" id="password" v-model="password" required />
      </div>
      <button type="submit" class="btn primary" :disabled="loading">
        <template v-if="loading">Загрузка...</template>
        <template v-else>Войти</template>
      </button>
    </form>


  </div>
</template>

<script>
import axios from "axios";
import {mapActions} from "vuex";
import {getConfig} from "@/store";

export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      error: null,
    };
  },
  methods: {
    ...mapActions(['fetchData']),
    async login() {
      this.loading = true;
      this.error = null;

      try {
        const response = await axios.post(getConfig().serverURL + "/server/login.php", {
          username: this.username,
          password: this.password,
        });

        if (response.data.success) {
          localStorage.setItem("authToken", response.data.token);
          await this.fetchData();
          this.$router.push("/admin/home");
        } else {
          this.error = response.data.message;
        }
      } catch (error) {
        this.error = "Ошибка при авторизации";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>